import { render, staticRenderFns } from "./SocialMediaSubscriptionButton.vue?vue&type=template&id=6d85d088"
import script from "./SocialMediaSubscriptionButton.vue?vue&type=script&lang=js"
export * from "./SocialMediaSubscriptionButton.vue?vue&type=script&lang=js"
import "./SocialMediaSubscriptionButton.vue?vue&type=style&index=0&id=6d85d088&prod&lang=scss"
import "./SocialMediaSubscriptionButton.vue?vue&type=style&index=1&id=6d85d088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports